import { useEffect, useState } from "react";
import { apiFetch, formatLagosDateTime } from "./api";

const dashboardFinanceUsers = new Set([
  "kandarp.g@globusafriventures.com",
  "radhey.g@globusafriventures.com"
]);

function SiteDashboard({ user }) {
  const [sites, setSites] = useState([]);
  const [siteSearch, setSiteSearch] = useState("");
  const [newSite, setNewSite] = useState({
    name: "",
    status: "",
    disco: "",
    assigned_sbc: ""
  });

  const filteredSites = sites.filter(site =>
    (site.name || "").toLowerCase().includes(siteSearch.toLowerCase())
  );
  const canViewDashboardFinance = dashboardFinanceUsers.has((user?.email || "").toLowerCase());

  function loadSites() {
    apiFetch("/api/dashboard")
      .then(res => res.json())
      .then(data => {
        setSites(Array.isArray(data) ? data : []);
      });
  }

  useEffect(() => {
    loadSites();
  }, []);

  function createSite() {
    if (!newSite.name || !newSite.disco || !newSite.status) {
      alert("Fill all required fields");
      return;
    }

    apiFetch("/api/site", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(newSite)
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) {
          alert(data.error);
          return;
        }

        alert("Site created");
        setNewSite({
          name: "",
          status: "",
          disco: "",
          assigned_sbc: ""
        });
        loadSites();
      });
  }

  return (
    <div style={{ padding: "20px" }}>
      <button onClick={() => (window.location.href = "/")}>Back to Clients</button>
      <h2>ATC Dashboard</h2>

      <div style={{ marginBottom: "20px" }}>
        <h3>Create New Site</h3>

        <input
          placeholder="Site Name"
          value={newSite.name}
          onChange={(e) => setNewSite({ ...newSite, name: e.target.value })}
        />

        <select
          value={newSite.status}
          onChange={(e) =>
            setNewSite({ ...newSite, status: e.target.value })
          }
        >
          <option value="">Select Status</option>
          <option>TSS stage</option>
          <option>Allotment of Project to SBC</option>
          <option>Delivery of Materials to site</option>
          <option>Completion of Installation works</option>
          <option>Testing, Commissioning, and Handover</option>
          <option>Site work complete</option>
        </select>

        <input
          placeholder="DISCO"
          value={newSite.disco}
          onChange={(e) => setNewSite({ ...newSite, disco: e.target.value })}
        />

        <input
          placeholder="SBC"
          value={newSite.assigned_sbc}
          onChange={(e) => setNewSite({ ...newSite, assigned_sbc: e.target.value })}
        />

        <button onClick={createSite}>Create Site</button>
      </div>

      <div style={{ marginBottom: "10px" }}>
        <input
          placeholder="Search site name..."
          value={siteSearch}
          onChange={(e) => setSiteSearch(e.target.value)}
          style={{ padding: "8px", width: "280px" }}
        />
      </div>

      <table border="1" cellPadding="10">
        <thead>
          <tr>
            <th>Site</th>
            <th>Status</th>
            <th>Expense (₦)</th>
            {canViewDashboardFinance && <th>Received (₦)</th>}
            {canViewDashboardFinance && <th>Profit (₦)</th>}
            <th>Open Issues</th>
            <th>Date Last Edited</th>
            <th>Last Edited By</th>
          </tr>
        </thead>

        <tbody>
          {filteredSites.length > 0 ? (
            filteredSites.map(s => (
              <tr
                key={s.id}
                style={{ cursor: "pointer" }}
                onClick={() => (window.location.href = `/site/${s.id}`)}
              >
                <td>{s.name}</td>
                <td>{s.status}</td>
                <td>{s.expense}</td>
                {canViewDashboardFinance && <td>{s.received}</td>}
                {canViewDashboardFinance && <td>{s.profit}</td>}
                <td>{s.issues}</td>
                <td>{formatLagosDateTime(s.last_edited_at)}</td>
                <td>{s.last_edited_by || ""}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={canViewDashboardFinance ? "8" : "6"}>No sites found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default SiteDashboard;
